<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import Icon from '@/ui/base/icon/Icon.svelte';

  export interface TaskMasterProps {
    taskLabel: string;
    done?: boolean;
  }
</script>

<script lang="ts">
  let { ...props }: TaskMasterProps = $props();

  const iconStyles = tv({
    base: 'size-4',
    variants: {
      done: {
        true: 'text-c-success',
        false: 'text-c-disabled',
      },
    },
  });
</script>

<div class="flex items-center gap-2">
  <Icon icon="CheckCircle" class={iconStyles({ done: props.done ?? false })}></Icon>
  <div class="w-full rounded-sm bg-prim p-3">
    <p class="font-sans text-sm font-normal text-c-base">{props.taskLabel}</p>
  </div>
</div>
